import { BASE_API_URL } from "../constants";

export const getAvailableReports = async (reportLevel = "basic") => {
  try {
    let type = "Basic";
    if (reportLevel === "advanced") {
      type = "Advanced";
    } else if (reportLevel === "diagnostic") {
      type = "Diagnostic";
    }

    const url = new URL(`${BASE_API_URL}client/reports`);
    url.searchParams.append("Type", type);

    const response = await fetch(url.toString(), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-t": `Bearer ${localStorage.getItem("token")}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    if (data.error) {
      throw new Error(data.message || "Failed to fetch reports");
    }

    return { success: true, data: data.data };
  } catch (error) {
    console.error("Error fetching available reports:", error);
    return { success: false, error: error.message };
  }
};
